import React, { useContext, useEffect } from 'react'
import { CardHeader, Typography, Box, Grid } from '@mui/material'
import { ScheduleDaySlider } from '../../../Complex'
import { DiariaButton, Loading } from '../../../Simple'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { PiChatCircleDots } from 'react-icons/pi'

export default function DiariasList() {
  //
  const { sttPg, loads, actionsCtxEmps } = useContext(EmpresasContext)

  useEffect(() => {
    actionsCtxEmps.BuscarDiariasEmpresa()
  }, [sttPg.selectedDay])

  return (
    <>
      <CardHeader
        title={
          <Typography variant='h5' align='center'>
            Marcar diária
          </Typography>
        }
      />
      <Box className='tw-mb-6'>
        <ScheduleDaySlider />
      </Box>
      <Grid container spacing={2}>
        {loads.diarias ? (
          <Grid item xs={12}>
            <Loading text={'Carregando diárias'} />
          </Grid>
        ) : sttPg.diarias.length ? (
          sttPg.diarias.map((diaria, index) => (
            <Grid item xs key={index} sx={{ display: 'flex', justifyContent: 'center' }}>
              <DiariaButton diaria={diaria} />
            </Grid>
          ))
        ) : (
          <Grid item xs={12} sx={{ marginY: '50px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <PiChatCircleDots size={50} color='#424242' />
            </Box>
            <Typography variant='body1' align='center' color={'text.secondary'}>
              Nenhuma diária disponível neste dia
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  )
}
